(() => {
  if (customElements.get('brand-delivery-estimate')) return;

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        clearTimeout(this.midnightTimer);
        this.updateDates();
        const now = new Date();
        const nextDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
        this.midnightTimer = setTimeout(this.refresh, nextDay - now + 1000);
      };
      this.onVisibility = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.refresh();
    }

    disconnectedCallback() {
      clearTimeout(this.midnightTimer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    updateDates() {
      const min = Number(this.dataset.minDays);
      const max = Number(this.dataset.maxDays);
      const output = this.querySelector('[data-delivery-range]');
      if (!output || !Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max < min) return;

      // Calendar-date arithmetic includes weekends and stays correct across DST changes.
      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth(), now.getDate() + min, 12);
      const to = new Date(now.getFullYear(), now.getMonth(), now.getDate() + max, 12);
      const options = { month: 'short', day: 'numeric' };
      if (from.getFullYear() !== now.getFullYear() || to.getFullYear() !== now.getFullYear()) options.year = 'numeric';
      const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', options);
      const time = date => {
        const element = document.createElement('time');
        element.dateTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        element.textContent = formatter.format(date);
        return element;
      };
      output.replaceChildren(time(from), document.createTextNode(' – '), time(to));
    }
  }

  customElements.define('brand-delivery-estimate', DeliveryEstimate);
})();
